<template>
  <div class="shop-upload-identification">
    <!-- <p class="notification is-dark">
      {{ memberRole.data }}
    </p> -->
    <p style="margin-bottom: 12px">
      A government-issued identification is required to place an order with this
      shop. You must be over 20 years old to receive the order.
    </p>
    <div v-if="IDPicURL">
      <div class="button is-fullwidth is-info" @click="confirmID">
        <p>
          <i class="fa fa-check-circle payment-icon" />
          <span class="payment-name">Confirm Your ID</span>
        </p>
      </div>
      <div class="is-divider" data-content="OR"></div>
      <div
        class="button is-fullwidth is-warning"
        style="margin-top: 10px"
        @click="triggerUploadIDPhoto"
      >
        <p>
          <i class="fa fa-id-card payment-icon" />
          <span class="payment-name">Upload New ID</span>
        </p>
      </div>
    </div>
    <div
      v-else
      class="button is-fullwidth is-warning"
      @click="triggerUploadIDPhoto"
    >
      <p>
        <i class="fa fa-id-card payment-icon" />
        <span class="payment-name">Upload Your ID</span>
      </p>
    </div>

    <div class="id-pic-wrapper">
      <img :src="IDPicURL" />
    </div>

    <input
      type="file"
      ref="file"
      style="display: none"
      accept="image/png,image/jpeg,image/jpg,image/bmp"
      @change="uploadPhoto($event)"
    />
  </div>
</template>


<script>
import photos from "@/photos";

export default {
  name: "ShopUploadIdentification",
  components: {},
  props: {
    workflowID: String,
  },
  data() {
    return {
      photoUploading: null,
    };
  },
  computed: {
    memberRole() {
      return this.$store.state.roles.find((r) => {
        return r.role_name === "Member" && r.workflow_id === this.workflowID;
      });
    },
    IDPicURL() {
      if (!this.memberRole) return null;
      return this.memberRole.data.id_pic_url;
    },
  },
  mounted() {},
  methods: {
    confirmID() {
      this.$emit("close", this.IDPicURL);
    },
    triggerUploadIDPhoto() {
      this.$refs.file.click();
      var loader = this.loadingDots("lightblue");
      setTimeout(() => loader.hide(), 5000);
    },
    uploadPhoto(e) {
      var dir = "identification";
      var filename = this.$shortid.generate();
      var businessID = `${this.$store.getters.getUserID}_${this.workflowID}`; // not a businessID
      var callback = this.attachIDPhoto;
      this.photoUploading = this.loadingDots("lightgreen");
      photos.uploadPhoto(e, this.$store, callback, dir, filename, businessID);
    },
    attachIDPhoto(picURL) {
      var data = this.memberRole.data; // send all the data back, not just is_busy
      data.id_pic_url = picURL;
      var payload = { id: this.memberRole.id, data: data };
      this.$store
        .dispatch("updateRoleData", payload) // setRoleIsBusy
        .then((res) => {
          this.console("updateRoleData", res);
          this.successToast("Identification Submitted");
          var nameAndNumber = this.$store.getters.getNameAndNumber;
          this.log("upload_member_identification_success", nameAndNumber);
          var msg = `🪪 Customer [ ${nameAndNumber} ] 🔐 uploaded member identification`;
          this.sendSuperuserNotification(msg);
          // should update role here
        })
        .catch((err) => this.apiError(err))
        .finally(() => this.photoUploading.hide());
    },
  },
};
</script>

<style scoped>
.shop-upload-identification {
  margin-bottom: 4px;
}
.button p {
  width: 100%;
  text-align: left;
  display: table;
  font-weight: 550;
}
.payment-icon {
  width: 36px;
  margin-top: 4px;
  font-size: 1.3em;
}
.id-pic-wrapper {
  margin-top: 16px;
  box-shadow: 0 0 2px grey;
  border-radius: 4px;
}
</style>